
import { computed, defineComponent, onMounted } from "vue";
import { DOCUMENT_TYPES, documentService, GetBallot } from "@/services";
import { useRouter } from "vue-router";
import { useGeneralActions } from "@/utils/actions";
import TransactionStatement from "@/components/transaction-statement/Main.vue";
import Pagination from "@/components/pagination/Main.vue";
import BallotReferenceLinks from "@/views/ballots/view/documents/ReferenceDocument.vue";

export default defineComponent({
  name: "BallotDocuments",
  components: { BallotReferenceLinks, Pagination, TransactionStatement },
  props: {
    permissions: {
      type: Object,
      default: () => ({}),
    },
    ballotId: { default: () => null },
    ballot: { type: Object as () => GetBallot, default: () => ({}) },
  },
  setup(props) {
    const router = useRouter();

    const { fetchRecords, filterRecords, deleteRecords } = useGeneralActions();
    const { fetch, loading, list } = fetchRecords({
      selectionQuery: {
        source: "document",
        config: {
          "@page": 1,
          "@select": [
            "id",
            "uuid",
            "n_number",
            "version",
            "title",
            "version",
            "file_extension",
            "file_path",
            "file_size",
            "language",
            "type",
            "created_at",
            "status",
          ],
          "@where": {
            resource_type: "ballot",
            resource_id: props.ballotId,
          },
          "@whereNot": {
            type: DOCUMENT_TYPES.BALLOT_COMMENTS,
          },
          "@func": ["withCount"],
          "@order": "created_at:desc",
        },
      },
    });

    const { filter, formattedQuery, changePage, changePerPage } = filterRecords(
      fetch,
      {
        page: 1,
        paginate: 15,
      },
      true
    );

    const {
      processing: deleteProcessing,
      transactionIds,
      triggerDelete,
    } = deleteRecords({
      deleteApiMethod: documentService.delete,
      successCallback(uuid) {
        if (uuid) {
          const index = _.findIndex(list.data, { uuid });
          if (index > -1) {
            list.data.splice(index, 1);
            list.meta.total--;
          }
        }
      },
    });

    const filesCount = computed(() => {
      return (
        _.get(list.meta, "total", 0) * 1 +
        _.get(props.ballot, "files", []).length
      );
    });

    const goToDocumentCreate = () => {
      router.push({
        name: "documents.create",
        params: {
          committeeId: props.ballot.committee_id,
        },
        query: {
          resource_type: "ballot",
          resource_id: props.ballotId as any,
        },
      });
    };

    const goToView = (uuid: any) => {
      router.push({ name: "documents", params: { uuid } });
    };

    const onAddDocumentReference = () => {
      cash("#reference-document-modal").modal("show");
    };

    onMounted(() => {
      fetch(formattedQuery()).finally();
    });

    return {
      loading,
      list,
      filter,
      deleteProcessing,
      transactionIds,
      triggerDelete,
      filesCount,
      changePage,
      changePerPage,
      goToDocumentCreate,
      onAddDocumentReference,
      goToView,
    };
  },
});
